import { useMatch, useParams } from 'react-router';

import type { Params } from '~/providers/RouterProvider/router.types';

import { useProducts } from '~/api/products';
import { Redirect } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { CreateEditProductForm } from './CreateEditProductForm';

export const CreateEditProduct = () => {
  const { data: products } = useProducts();

  const { productId } = useParams<Params<typeof routes.editProduct>>();
  const isEdit = !!useMatch(routes.editProduct);

  if (!isEdit) return <CreateEditProductForm mode="create" product={null} />;

  const product = products.find((product) => product.id === Number(productId));

  if (!product) return <Redirect to={routes.products} />;

  return <CreateEditProductForm mode="edit" product={product} />;
};
